export default __webpack_public_path__ + "static/media/shoe02.e03e1f32.jpg";